import {
  GreyGrey10,
  IconReceiptTax,
  IconPlus,
  Tooltip,
  Button,
  IconLayers,
  IconCoinStack,
  Flex
} from '@sequencehq/core-components'
import { PhaseHookInterface } from 'Cube/view/common/widgets/Pricing/Phase/usePhase'
import { FC } from 'react'
import { ProtectedButton } from 'lib/rbac'
import { usePhasePermissions } from 'Cube/utils/usePhasePermissions'

export const PhaseActions: FC<{ phasesHook: PhaseHookInterface }> = ({
  phasesHook
}) => {
  const { phaseUpdatePermission } = usePhasePermissions()

  return (
    <Flex
      justifyContent="space-between"
      bg={GreyGrey10}
      borderRadius="6px"
      padding="8px"
      gap="12px"
    >
      <Tooltip
        label={phasesHook.features.addProduct.reason}
        placement="top"
        data-testid="phase.addProduct.tooltip"
      >
        <ProtectedButton permission={phaseUpdatePermission}>
          <Button
            variant="secondary"
            disabled={phasesHook.features.addProduct.disabled}
            onClick={phasesHook.features.addProduct.handler}
            leadingIcon={<IconPlus color="inherit" />}
            data-testid="phase.addProduct"
          >
            Add product
          </Button>
        </ProtectedButton>
      </Tooltip>
      <Flex gap="8px">
        <Tooltip
          label={phasesHook.features.addDiscount.reason}
          placement="top"
          data-testid="phase.addDiscount.tooltip"
        >
          <ProtectedButton permission={phaseUpdatePermission}>
            <Button
              variant="secondary"
              disabled={phasesHook.features.addDiscount.disabled}
              onClick={phasesHook.features.addDiscount.handler}
              leadingIcon={<IconReceiptTax color="inherit" />}
              data-testid="phase.addDiscount"
            >
              Add discount
            </Button>
          </ProtectedButton>
        </Tooltip>
        <Tooltip
          label={phasesHook.features.addMinimum.reason}
          placement="top"
          data-testid="phase.addMinimum.tooltip"
        >
          <ProtectedButton permission={phaseUpdatePermission}>
            <Button
              variant="secondary"
              disabled={phasesHook.features.addMinimum.disabled}
              onClick={phasesHook.features.addMinimum.handler}
              leadingIcon={<IconLayers color="inherit" />}
              data-testid="phase.addMinimum"
            >
              Add minimum
            </Button>
          </ProtectedButton>
        </Tooltip>
        {phasesHook.features.addCredit.visible && (
          <Tooltip label={phasesHook.features.addCredit.reason} placement="top">
            <ProtectedButton permission={phaseUpdatePermission}>
              <Button
                variant="secondary"
                disabled={phasesHook.features.addCredit.disabled}
                onClick={phasesHook.features.addCredit.handler}
                leadingIcon={<IconCoinStack color="inherit" />}
                data-testid="phase.addCredit"
              >
                Add credits
              </Button>
            </ProtectedButton>
          </Tooltip>
        )}
      </Flex>
    </Flex>
  )
}
